// Deep-import wrapper. Re-exports from the single shared runtime so this
// subpath resolves to the same Module Federation singleton. Uses EXPLICIT named
// re-exports (NOT export *): export * over a federated shared module cannot
// enumerate the proxy export names and silently drops the bindings. See src/runtime.
export { useLanguageFallback, useLanguageState } from '@erpsquad/common/runtime';
export type { ILanguage, FallbackConfig } from '@erpsquad/common/runtime';
import { useLanguageFallback, useLanguageState } from '@erpsquad/common/runtime';
export default { useLanguageFallback, useLanguageState };
